export function clickPositionX(event: MouseEvent, onEl?: Element) {
  const el = onEl ?? event.target as HTMLElement
  if (!el) {
    return
  }
  const { left } = el.getBoundingClientRect()
  return event.clientX - left
}
